import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { PageResponse } from '@models/api';
import { CountryResponse, getAllCountries } from '@apis/country';

export const useCountryList = () => {
  const queryOptions: UseQueryOptions<PageResponse<CountryResponse>, Error> = {
    queryKey: ['countries'],
    queryFn: () => {
      return getAllCountries();
    },
  };
  return useQuery(queryOptions);
};
